import { render } from "./eye_investigations.vue?vue&type=template&id=2de445a1&scoped=true"
import script from "./eye_investigations.vue?vue&type=script&lang=js"
export * from "./eye_investigations.vue?vue&type=script&lang=js"

import "./eye_investigations.vue?vue&type=style&index=0&id=2de445a1&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de445a1"]])

export default __exports__